export default {
  customDashboard: {
    loading: 'Laden...',
    loadingData: 'Daten werden geladen...',
    selectedSensors: '{count} ausgewählte Sensoren',
    addNewChart: 'Neues Diagramm hinzufügen',
    chartTitle: 'Diagrammtitel',
    selectSensors: 'Sensoren auswählen',
    selectSensorValidation: 'Wählen Sie mindestens einen Sensor aus',
    chartType: 'Diagrammtyp',
    selectChartType: 'Wählen Sie einen Diagrammtyp',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    invalidDateRange: 'Ungültiger Datumsbereich',
    sensorColors: 'Sensorfarben',
    others: 'andere',
    buttons: {
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
      update: 'Aktualisieren'
    },
    editChart: 'Diagramm bearbeiten',
    buttonColors: {
      green: '{sensorName} - Grün',
      yellow: '{sensorName} - Gelb',
      red: '{sensorName} - Rot'
    },
    selectDateRange: 'Datumsbereich auswählen',
    quickFilters: 'Schnellfilter',
    weeklyConsumption: 'Wöchentlicher Verbrauch',
    dataManager: 'Datenmanager',
    lastRefilling: 'Letzte Auffüllung',
    dispenserLevel: 'Spenderfüllstand',
    time: 'Zeit',
    levelStatus: 'Füllstandstatus',
    fullEmptyDispenser: 'Voller/Leerer Spender',
    emptyHours: 'Leere Stunden',
    consumptions: 'Verbrauch',
    downloadChartData: 'Diagrammdaten herunterladen',
    downloadAllData: 'Alle Daten herunterladen',
    addNewWidget: 'Neues Widget hinzufügen',
    widgetType: 'Widget-Typ',
    chartTemplate: 'Diagrammvorlage',
    comparisonLevel: 'Vergleichsebene',
    entitiesToCompare: 'Zu vergleichende Entitäten',
    period: 'Zeitraum',
    widgetTitle: 'Widget-Titel',
    size: 'Größe',
    filters: {
      title: 'Filter',
      clients: 'Kunden',
      buildings: 'Gebäude',
      floors: 'Etagen',
      areas: 'Bereiche',
      dispenserType: 'Spendertyp',
      productType: 'Produkttyp',
      selectAll: 'Alle auswählen',
      deselectAll: 'Alle abwählen'
    },
    sizes: {
      small: 'Klein',
      medium: 'Mittel',
      large: 'Groß'
    },
    kpiType: 'KPI-Typ',
    dataLevel: 'Datenebene',
    articleType: 'Artikeltyp',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    kpiTypes: {
      totalConsumption: {
        title: 'Gesamter Papierverbrauch',
        description: 'Gesamtes Papier im ausgewählten Zeitraum verbraucht'
      },
      averageDaily: {
        title: 'Durchschnittlicher Tagesverbrauch',
        description: 'Durchschnittlicher Papierverbrauch pro Tag'
      },
      mostUsedArticle: {
        title: 'Meistverwendeter Artikel',
        description: 'Meistverwendeter Papiertyp nach Prozentsatz'
      },
      inactiveZones: {
        title: 'Inaktive Zonen',
        description: 'Anzahl der Bereiche ohne Aktivität im ausgewählten Zeitraum'
      },
      estimatedCost: {
        title: 'Geschätzte Papierkosten',
        description: 'Geschätzte Kosten für Papier im ausgewählten Zeitraum'
      },
      peakUsageDay: {
        title: 'Tag mit Spitzenverbrauch',
        description: 'Der Tag mit dem höchsten Verbrauch im ausgewählten Zeitraum'
      }
    },
    chartTypes: {
      paperConsumption: {
        title: 'Papierverbrauch',
        description: 'Gesamten Papierverbrauch vergleichen'
      },
      usageFrequency: {
        title: 'Nutzungshäufigkeit',
        description: 'Vergleichen Sie, wie oft Bereiche genutzt werden'
      },
      paperCost: {
        title: 'Papierkosten',
        description: 'Geschätzte Kosten des Papierverbrauchs vergleichen'
      },
      alertEvents: {
        title: 'Alarmereignisse',
        description: 'Vergleichen Sie, wie viele Alarmereignisse aufgetreten sind'
      },
      consumptionVsFrequency: {
        title: 'Verbrauch vs. Häufigkeit',
        description: 'Vergleichen Sie die tägliche Nutzungshäufigkeit mit dem Papierverbrauch für einen ausgewählten Bereich'
      },
      sensorComparison: {
        title: 'Sensorvergleich',
        description: 'Historische Daten zwischen ausgewählten Sensoren vergleichen'
      },
      consumptionVsBathroom: {
        title: 'Verbrauch vs. Toilettennutzung',
        description: 'Korrelation zwischen Papierverbrauch und Toilettennutzungshäufigkeit'
      }
    },
    sensorCategories: {
      dispenser: 'Spender',
      doors: 'Türen'
    },
    sensorComparison: {
      title: 'Sensorvergleich',
      selectSensors: 'Sensoren zum Vergleichen auswählen',
      selectCategory: 'Kategorie auswählen',
      noSensorsSelected: 'Wählen Sie mindestens einen Sensor zum Vergleichen aus',
      loading: 'Sensordaten werden geladen...'
    }
  },
  sensor: {
    error: {
      loading: 'Fehler beim Laden der Sensordetails',
      updating: 'Fehler beim Aktualisieren des Sensors',
      requiredFields: 'Bitte füllen Sie alle erforderlichen Felder aus',
      title: 'Fehler',
      emptyFields: 'Die folgenden Felder sind erforderlich: {fields}',
      duplicateDevEui: 'Diese Sensor-ID existiert bereits im System',
      creation: 'Fehler beim Erstellen des Sensors',
    },
    add: {
      title: 'SENSOR-SCHNELLEINRICHTUNG: Bitte füllen Sie die folgenden Felder aus'
    },
    fields: {
      sensorId: 'Sensor-ID',
      dispenserName: 'Spendername',
      dispenserBrand: 'Spendermarke',
      dispenserArticleCode: 'Spender-Artikelcode',
      consumableBrand: 'Verbrauchsmaterialmarke',
      consumableArticleCode: 'Verbrauchsmaterial-Artikelcode',
      client: 'Kunde',
      building: 'Gebäude',
      floor: 'Etage',
      area: 'Bereich'
    },
    selectDispenser: 'Spender auswählen',
    notManagedYet: 'Noch nicht verwaltet',
    emptyHours: 'Leere Stunden',
    full: 'Voll',
    empty: 'Leer'
  },
  login: {
    title: 'Anmeldung',
    button: 'Anmelden',
    username: 'Benutzername',
    password: 'Passwort',
    error: 'Falscher Benutzername oder Passwort!',
    close: 'Schließen',
    forgotPassword: 'Passwort vergessen',
    resetPassword: 'Passwort zurücksetzen',
    resetPasswordInstructions: 'Bitte geben Sie die E-Mail-Adresse ein, die bei der Registrierung verwendet wurde',
    email: 'E-Mail',
    resetRequested: 'Zurücksetzung angefordert für:',
    enterNewPassword: 'Geben Sie Ihr neues Passwort in die Felder unten ein (stellen Sie sicher, dass beide Passwörter identisch sind, um fortzufahren)',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Neues Passwort bestätigen',
    passwordsDontMatch: 'Die Passwörter stimmen nicht überein'
  },
  KEY001: 'Anmeldung',
  key006: 'Falscher Benutzername oder Passwort!',
  key007: 'Schließen',
  validation: {
    required: 'Dieses Feld ist erforderlich',
    duplicateDevEui: 'Diese Sensor-ID existiert bereits'
  },
  building: {
    add: {
      title: 'NEUES GEBÄUDE ERSTELLEN: Bitte füllen Sie die folgenden Felder aus'
    },
    fields: {
      name: 'Gebäudename',
      address: 'Gebäudeadresse'
    },
    error: {
      creation: 'Fehler beim Erstellen des Gebäudes'
    }
  },
  floor: {
    add: {
      title: 'NEUE ETAGE ERSTELLEN: Bitte füllen Sie die folgenden Felder aus'
    },
    fields: {
      name: 'Etagenname',
      building: 'Gebäude'
    },
    error: {
      creation: 'Fehler beim Erstellen der Etage'
    }
  },
  area: {
    add: {
      title: 'NEUEN BEREICH ERSTELLEN: Bitte füllen Sie die folgenden Felder aus'
    },
    fields: {
      name: 'Bereichsname',
      building: 'Gebäude',
      floor: 'Etage'
    },
    error: {
      creation: 'Fehler beim Erstellen des Bereichs'
    }
  },
  washroomFrequency: {
    selectSensor: 'Wählen Sie einen Toilettensensor aus, um fortzufahren',
    loading: 'Laden...',
    client: 'Kunde',
    building: 'Gebäude',
    floor: 'Etage',
    area: 'Bereich',
    sensor: 'Sensor',
    back: 'ZURÜCK',
    ok: 'OK',
    quickFilters: 'Schnellfilter:',
    hours: '4 STUNDEN',
    day: '1 TAG',
    week: '1 WOCHE',
    twoWeeks: '2 WOCHEN',
    thirtyDays: '30 TAGE',
    selectDateRange: 'Datumsbereich auswählen',
    cancel: 'Abbrechen',
    dataManager: 'DATENMANAGER',
    sensorName: 'Sensorname:',
    cleaningSchedule: 'REINIGUNGSPLAN',
    washroomUsageFrequency: 'TOILETTENNUTZUNGSHÄUFIGKEIT',
    lastCleaning: 'Letzte Reinigung:',
    cleaningStatus: 'Reinigungsstatus:',
    alertThreshold: 'Alarmschwelle:',
    events: 'Ereignisse',
    cleaningRequired: 'Reinigung erforderlich',
    mightNeedClean: 'Könnte Reinigung benötigen',
    doesntNeedClean: 'Benötigt keine Reinigung'
  },
  manageSensors: {
    title: 'Sensoren verwalten',
    addNewSensor: 'Neuen Sensor hinzufügen',
    sensorDeleting: 'Sensor wird gelöscht',
    deleteConfirm: 'Sind Sie sicher, dass Sie "{name}" löschen möchten?',
    client: 'Kunde',
    building: 'Gebäude',
    floor: 'Etage',
    area: 'Bereich',
    sensor: 'Sensor',
    clearFilter: 'Filter löschen',
    filter: 'Filter',
    type: 'Typ',
    fillLevel: 'Füllstand',
    liveUsage: 'Aktuelle Nutzung',
    cleaningLimit: 'Reinigungsschwelle',
    name: 'Name',
    company: 'Unternehmen',
    battery: 'Batterie',
    sensorId: 'Sensor-ID',
    actions: 'Aktionen',
    editSensor: 'SENSOR BEARBEITEN',
    update: 'Aktualisieren',
    noDataAvailable: 'Keine Daten verfügbar'
  },
  alerts: {
    title: 'Alarme',
    alertTime: 'ALARMZEIT',
    solvedTime: 'GELÖST ZEIT',
    message: 'NACHRICHT',
    markAsDone: 'Als erledigt markieren',
    triggerAt: 'Ausgelöst am',
    resolvedAt: 'Gelöst am',
    duration: 'Dauer'
  },
  dashboard: {
    title: 'Dashboard',
    overview: 'Übersicht',
    statistics: 'Statistiken',
    editWidget: 'Widget bearbeiten',
    addWidget: 'Widget hinzufügen',
    widgetSize: 'Widget-Größe',
    size: 'Größe',
    small: 'Klein',
    medium: 'Mittel',
    large: 'Groß',
    sizes: {
      small: 'Klein',
      smallDesc: '1/4 Breite - Kompakte Widgets',
      medium: 'Mittel',
      mediumDesc: '1/2 Breite - Standard-Widgets',
      large: 'Groß',
      largeDesc: 'Volle Breite - Große Widgets'
    }
  },
  alertsManagement: {
    pageTitle: 'Alarmverwaltung',
    createRule: 'Neue Regel erstellen',
    fillFields: 'Bitte füllen Sie die folgenden Felder aus',
    title: 'Titel',
    email: 'E-Mail (verwenden Sie ; zum Trennen von E-Mails)',
    customMessage: 'Fügen Sie hier Ihre benutzerdefinierte Nachricht ein:',
    alertValue: 'Alarmwert (%) - Anzahl der Ereignisse',
    saveRule: 'Regel speichern',
    sensor: 'SENSOR',
    emailAddresses: 'E-MAIL-ADRESSEN',
    active: 'AKTIV',
    phoneNumbers: 'TELEFONNUMMERN',
    deleteConfirm: {
      title: 'Löschung bestätigen',
      message: 'Sind Sie sicher, dass Sie die Regel "{title}" löschen möchten?',
      description: 'Diese Aktion kann nicht rückgängig gemacht werden.'
    }
  },
  users: {
    title: 'Benutzer',
    manageUser: 'Benutzer verwalten',
    username: 'BENUTZERNAME',
    role: 'ROLLE',
    active: 'AKTIV'
  },
  buildings: {
    title: 'Gebäude',
    name: 'Name',
    address: 'Adresse',
    sensors: 'Sensoren'
  },
  smartDispenser: {
    selectSensor: 'Wählen Sie einen Smart-Spender aus, um fortzufahren',
    loading: 'Laden...',
    quickFilters: 'Schnellfilter:',
    hours: '4 STUNDEN',
    day: '1 TAG',
    threeDays: '3 TAGE',
    week: '1 WOCHE',
    twoWeeks: '2 WOCHEN',
    lastMonth: 'LETZTER MONAT',
    selectDateRange: 'Datumsbereich auswählen',
    dataManager: 'DATENMANAGER',
    sensorName: 'Sensorname:',
    lastRefill: 'Letzte Auffüllung:',
    consumption: 'Verbrauch:',
    binLevel: 'BEHÄLTERFÜLLSTAND',
    dispenserLevel: 'SPENDERFÜLLSTAND',
    dispenserAvailability: 'SPENDERVERFÜGBARKEIT – % VOLL vs LEER',
    dispenserDowntime: 'SPENDER-AUSFALLZEIT – LEERE STUNDEN / TAG',
    consumptions: 'VERBRAUCH',
    downloadChartData: 'Diagrammdaten herunterladen',
    downloadAllData: 'Alle Sensordaten herunterladen',
    refillSchedule: 'NACHFÜLLPLAN',
    levelStatus: 'Füllstandstatus:',
    time: 'Zeit:'
  },
  smartBin: {
    selectSensor: 'Wählen Sie einen Smart-Behälter aus, um fortzufahren',
    binLevel: 'BEHÄLTERFÜLLSTAND',
    binFillLevel: 'BEHÄLTERFÜLLSTAND – NIVEAU',
    averageFillingLevel: 'DURCHSCHNITTLICHER FÜLLSTAND',
    fillLevel: 'Füllstand'
  },
  airQuality: {
    selectSensor: 'Wählen Sie einen Luftqualitätssensor aus, um fortzufahren',
    co2Level: 'CO2-NIVEAU',
    temperature: 'TEMPERATUR',
    humidity: 'LUFTFEUCHTIGKEIT',
    averageCo2: 'DURCHSCHNITTLICHES CO2-NIVEAU'
  },
  sensorDetails: {
    sensorDetails: 'Sensordetails',
    deviceInfo: 'Geräteinformationen',
    location: 'Standort',
    status: 'Status',
    lastUpdate: 'Letzte Aktualisierung'
  },
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    ok: 'OK',
    confirm: 'Bestätigen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    add: 'Hinzufügen',
    close: 'Schließen',
    back: 'Zurück',
    next: 'Weiter',
    continue: 'Fortfahren',
    search: 'Suchen',
    loading: 'Laden...',
    noDataAvailable: 'Keine Daten verfügbar',
    yes: 'Ja',
    no: 'Nein',
    saveChanges: 'Änderungen speichern',
    days: {
      sunday: 'Sonntag',
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag'
    }
  },
}
